module.exports = __webpack_public_path__ + "img/ppt.3d2467b1.png";